module.exports = __webpack_public_path__ + "static/media/china_paper_cups_getty_desktop.d4261b8d.jpg";